import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propBool, propFunc, propStr, } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import ModalHoc from '../../../Ui/Modal/ModalHoc';
import ModalPortalHoc from '../../../Ui/Modal/ModalPortalHoc';
import TutorialModalOnBoardingBody from './TutorialModal/TutorialModalOnBoardingBody';
const SlideSearchTutorialModalInner = (props) => {
    const { hideModal, isFree, modalState } = props;
    return (_jsxs("div", Object.assign({ className: 'slide_search_top_page' }, { children: [_jsx("div", { className: clsx('fixed_modal_bg bg-modal animated-opacity', modalState), role: 'presentation' }), _jsx("div", Object.assign({ className: clsx('slide_search_tutorial_modal fixed_modal animated-opacity', modalState) }, { children: _jsx("div", Object.assign({ className: 'slide_search_tutorial_modal_body' }, { children: _jsx(TutorialModalOnBoardingBody, { hideModal: hideModal, isFree: isFree }) })) }))] })));
};
SlideSearchTutorialModalInner.propTypes = {
    hideModal: propFunc().isRequired,
    isFree: propBool().isRequired,
    modalState: propStr().isRequired,
};
const SlideSearchTutorialModal = compose(ModalPortalHoc({ selector: '#app' }), ModalHoc)(SlideSearchTutorialModalInner);
SlideSearchTutorialModal.propTypes = {
    hideModal: propFunc().isRequired,
    isFree: propBool().isRequired,
    isShow: propBool().isRequired,
};
export default SlideSearchTutorialModal;
